import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';

import {IndexLink, Link, withRouter} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class TalentPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div>
                <div className="advertise_boxs" id={isMobile?"t_welcome_mobile":"t_welcome"}>
                    <div className={"block-001"}>
						<Link to="/business">
							<img className={"img_logo"} src="/static/img/appimg/h_logo.png"/>
						</Link>
                        <Link className="btn_login" to="/signin">Sign in</Link>
                        {isMobile?
                            <MenuComponent is_hide={2}/>
                            :""
                        }
                    </div>
                    <div className={"block-002"}>
                        {isMobile?<img className={"icon_cc"} src="/static/img/appimg/tl_img1_mobile.png"/>:""}
                        <div className={"content"}>
                            <p>&nbsp;</p>
                            <h2>Your next university hire is here</h2>
                            <p>Find and engage the right talent, build your brand, and make even smarter hires.</p>
                            <Link to="/talent/contact-us">Request a free demo</Link>
                        </div>
                    </div>
                    <div className={"block-003"}>
                        <div className={"content1"}>
                            <div className={"item-01"}>Recruit from <small>the Largest<br/> University Network</small></div>
                            <div className={"item-02"}>
                                <img src="/static/img/appimg/tl_icon1.png"/>
                                <span>4,000+</span>
                                <span>colleges and universities in your college search to target students and recent grads</span>
                            </div>
                            <div className={"item-03"}>
                                <img src="/static/img/appimg/tl_icon2.png"/>
                                <span>Over 370,000</span>
                                <span>employers within our network actively searching for and hiring top entry-level talent</span>
                            </div>
                            <p>&nbsp;</p>
                        </div>
                        <div className={"content2"}>
                            <p>Get your company in front of the right students</p>
                            {isMobile ?
                                <div className={"item-002"}>
                                    <div className={"right"}>
                                        <ul>
                                            <li>
                                                <img src="/static/img/appimg/tl_icon3.png"/>
                                                <div className={"sub-right"}>
                                                    <h2>Kyle Lowry</h2>
                                                    <p>Florida State University</p>
                                                    <p>
                                                        <small>Bachelors</small>
                                                        <small>Class of 2020</small>
                                                        <small>3.5 GPA</small>
                                                        <small><span className="glyphicon glyphicon-map-marker"
                                                                     aria-hidden="true"></span> Tallahassee, FL
                                                        </small>
                                                    </p>
                                                    <p>
                                                        <small>HTML5</small>
                                                        <small>PSD to HTML</small>
                                                        <small>Javascript</small>
                                                        <small>iQuery</small>
                                                        <small>6 more</small>
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="/static/img/appimg/tl_icon4.png"/>
                                                <div className={"sub-right"}>
                                                    <h2>Kirsten Michaels</h2>
                                                    <p>Yale University</p>
                                                    <p>
                                                        <small>Bachelors</small>
                                                        <small>Class of 2023</small>
                                                        <small>3.7 GPA</small>
                                                        <small><span className="glyphicon glyphicon-map-marker"
                                                                     aria-hidden="true"></span> New Haven, CT
                                                        </small>
                                                    </p>
                                                    <p>
                                                        <small>Computer - Aided Design</small>
                                                        <small>SolidWorks</small>
                                                        <small>5 more</small>
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className={"left"}>
                                        <ul>
                                            <li>
                                                <h2>Hiring Interns?</h2>
                                                <p>Join companies that have posted internships on Versity</p>
                                                <div className={"btns"}><Link to="/talent/post-a-job">Post a internship
                                                    </Link><span><Link className={"more"} to="/talent/contact-us">Learn more ></Link></span>
                                                </div>
                                            </li>
                                            <li>
                                                <h2>Hiring 3+ people a year?</h2>
                                                <p>Job Slosts are a cost-effective way to post multiple open roles</p>
                                                <div className={"btns"}><Link to="/talent/contact-us">Request a free
                                                    demo</Link><span><Link className={"more"} to="/talent/contact-us">Learn more ></Link></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                :
                                <div className={"item-002"}>
                                    <div className={"left"}>
                                        <ul>
                                            <li>
                                                <h2>Hiring Interns?</h2>
                                                <p>Join companies that have posted internships on Versity</p>
                                                <div className={"btns"}><Link to="/talent/post-a-job">Post a internship
                                                    </Link><span><Link className={"more"} to="/talent/contact-us">Learn more ></Link></span>
                                                </div>
                                            </li>
                                            <li>
                                                <h2>Hiring 3+ people a year?</h2>
                                                <p>Job Slosts are a cost-effective way to post multiple open roles</p>
                                                <div className={"btns"}><Link to="/talent/contact-us">Request a free
                                                    demo</Link><span><Link className={"more"} to="/talent/contact-us">Learn more ></Link></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className={"right"}>
                                        <ul>
                                            <li>
                                                <img src="/static/img/appimg/tl_icon3.png"/>
                                                <div className={"sub-right"}>
                                                    <h2>Kyle Lowry</h2>
                                                    <p>Florida State University</p>
                                                    <p>
                                                        <small>Bachelors</small>
                                                        <small>Class of 2020</small>
                                                        <small>3.5 GPA</small>
                                                        <small><span className="glyphicon glyphicon-map-marker"
                                                                     aria-hidden="true"></span> Tallahassee, FL
                                                        </small>
                                                    </p>
                                                    <p>
                                                        <small>HTML5</small>
                                                        <small>PSD to HTML</small>
                                                        <small>Javascript</small>
                                                        <small>iQuery</small>
                                                        <small>6 more</small>
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <img src="/static/img/appimg/tl_icon4.png"/>
                                                <div className={"sub-right"}>
                                                    <h2>Kirsten Michaels</h2>
                                                    <p>Yale University</p>
                                                    <p>
                                                        <small>Bachelors</small>
                                                        <small>Class of 2023</small>
                                                        <small>3.7 GPA</small>
                                                        <small><span className="glyphicon glyphicon-map-marker"
                                                                     aria-hidden="true"></span> New Haven, CT
                                                        </small>
                                                    </p>
                                                    <p>
                                                        <small>Computer - Aided Design</small>
                                                        <small>SolidWorks</small>
                                                        <small>5 more</small>
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={"content3"}>
                            <p>Reach the right candidates, right now</p>
                            {isMobile ?
                                <div className={"item-002"}>
                                    <img className="icon_cc" src="/static/img/appimg/tl_img2.png"/>
                                    <div className={"left"}>
                                        <ul>
                                            <li>
                                                <h2>Versity Jobs</h2>
                                                <p>A recruiting platform for those that need to constantly and
                                                    consistently find, connect with, and manage the right
                                                    candidates.</p>
                                                <div className={"btns"}><Link to="/talent/contact-us">Request a Free
                                                    Demo</Link><span><Link className={"more"} to="/talent/contact-us"> Learn more ></Link></span>
                                                </div>
                                            </li>
                                            <li>
                                                <h2>Versity Internships</h2>
                                                <p>A lighter weight recruiting tool for those with occasional hiring
                                                    needs</p>
                                                <div className={"btns"}><Link to="/employers/signup">Get
                                                    Started</Link><span><Link className={"more"}
                                                                              to="/talent/contact-us"> Learn more ></Link></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                :
                                <div className={"item-002"}>
                                    <div className={"left"}>
                                        <ul>
                                            <li>
                                                <h2>Versity Jobs</h2>
                                                <p>A recruiting platform for those that need to constantly and
                                                    consistently find, connect with, and manage the right
                                                    candidates.</p>
                                                <div className={"btns"}><Link to="/talent/contact-us">Request a Free
                                                    Demo</Link><span><Link className={"more"} to="/talent/contact-us"> Learn more ></Link></span>
                                                </div>
                                            </li>
                                            <li>
                                                <h2>Versity Internships</h2>
                                                <p>A lighter weight recruiting tool for those with occasional hiring
                                                    needs</p>
                                                <div className={"btns"}><Link to="/employers/signup">Get
                                                    Started</Link><span><Link className={"more"}
                                                                              to="/talent/contact-us"> Learn more ></Link></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <img className="icon_cc" src="/static/img/appimg/tl_img2.png"/>
                                </div>
                            }
                        </div>
                        <div className={"content4"}>
                            <p>Share your company story and attract talent</p>
                            <div className={"item-002"}>
                                <img className="icon_cc" src="/static/img/appimg/tl_img3.png"/>
                                <div className={"right"}>
                                    <ul>
                                        <li>
                                            <h2>Company Pages</h2>
                                            <p>Ensure students learn more about your business or  brand, products and services, and job opportunities, with a free company profile.</p>
                                            <div className={"btns"}><Link to="/employers/signup">Get Started</Link><span><Link className={"more"} to="/companypages/contact-us"> Learn more ></Link></span></div>
                                        </li>
                                        <li>
                                            <h2>Page Publishing</h2>
                                            <p>Improve your brand visibility- share meaningful updates about your business.</p>
                                            <div className={"btns"}><Link to="/employers/signup">Get Started</Link><span><Link className={"more"} to="/promote/contact-us"> Learn more ></Link></span></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p>&nbsp;</p>
                        </div>
                        <div className={"content5"}>
                            <p>Get started today</p>
                            <Link to="/talent/contact-us">Request a free demo</Link>
                        </div>
                    </div>
                </div>

                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}
TalentPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(TalentPage));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/talent.js
 **/